import * as form from './form';
import * as list from './list';
import * as mantainDescription from './mantainDescription';

export const Actions = {
  ...form,
  ...list,
  ...mantainDescription,
};
